const fn = {
  init: () => {
    fn.setupSupplyChain()
  },

  setupSupplyChain: () => {
    const $itemSlider = $('.supply-chain-section').find('.supply-chain-slides')

    if (!$itemSlider.length) {
      return
    }

    $itemSlider.slick({
      arrows: true,
      dots: false,
      appendArrows: $('.supply-chain-section').find('.item-slider-controls'),
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><span>Back</span></button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Next"><span>Next</span></button>',
      adaptiveHeight: false,
      mobileFirst: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 479,
          settings: {
            variableWidth: true,
            slidesToShow: 2
          }
        }
      ]
    })
  }
}

export default {
  can: () => document.body.classList.contains('pagetype-hospitalhomepage'),
  run: fn.init
}
